import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

import home from 'images/side-navigation/home.svg'
import map from 'images/side-navigation/map.svg'
import faq from 'images/side-navigation/faq.svg'

import logout from 'images/side-navigation/logout.svg'
import { ARTIST_PORTAL_ROUTE } from 'config'
import {
  CommunityImage,
  PortalNavAdditionalLogos,
  ExternalLink,
} from 'components'
import classnames from 'classnames'

const propTypes = {
  community: PropTypes.object.isRequired,
  closeMobileNav: PropTypes.func.isRequired,
}

const defaultProps = {}

function SideNav({ community, closeMobileNav }) {
  const { defaultBranding } = community
  const {
    communityLogo,
    secondarySideBySideLogo,
    secondaryFooterLogo,
    thirdSideBySideLogo,
  } = defaultBranding
  const isAlabama = community.subdomain === 'alabama'
  const isSacramento = community.subdomain === 'sacramento'
  const taFaqUrl = community?.teachingArtist?.faqUrl

  return (
    <nav className="side-navigation" aria-label="Primary navigation">
      <div className="side-navigation-inner">
        <div className="logo-block">
          <div
            className={classnames('logo-block-inner', {
              'side-by-side': secondarySideBySideLogo,
            })}
          >
            {isAlabama ? (
              <CommunityImage image={secondaryFooterLogo} />
            ) : (
              <div>
                <CommunityImage image={communityLogo} />
                {!isSacramento && secondarySideBySideLogo && (
                  <div className="second-logo">
                    <CommunityImage image={secondarySideBySideLogo} />
                  </div>
                )}
                {thirdSideBySideLogo && (
                  <div className="third-logo">
                    <CommunityImage image={thirdSideBySideLogo} />
                  </div>
                )}
              </div>
            )}
          </div>
          <span className="visually-hidden">
            {community.name || community.subdomain || 'Community'}
          </span>
        </div>
        <ul>
          <li>
            <Link
              to={ARTIST_PORTAL_ROUTE + '/dashboard'}
              onClick={closeMobileNav}
            >
              <img src={home} alt="" /> Home
            </Link>
          </li>
          <li>
            <Link
              to={ARTIST_PORTAL_ROUTE + '/profile'}
              data-cy="profile-information"
              onClick={closeMobileNav}
            >
              <img src={map} alt="" data-cy="partner-profile-link" /> artlook
              Map Profile
            </Link>
          </li>
          {taFaqUrl && (
            <li>
              <ExternalLink href={taFaqUrl}>
                <img src={faq} alt="" /> FAQ
              </ExternalLink>
            </li>
          )}
          <li>
            <Link
              to={ARTIST_PORTAL_ROUTE + '/sign-out'}
              data-cy="sign-out-link"
              onClick={closeMobileNav}
            >
              <img src={logout} alt="" data-cy="partner-profile-link" /> Log out
            </Link>
          </li>
        </ul>
      </div>

      <PortalNavAdditionalLogos community={community} />
    </nav>
  )
}

SideNav.propTypes = propTypes
SideNav.defaultProps = defaultProps

export default SideNav
